export default "__VITE_ASSET__CLMTyMsI__"